export default ngModule => {
  ngModule.controller('RetrievePasswordCtrl',
    function (AonConfig, $http, $interpolate) {
      this.messages = {
        success: null,
        failure: null,
        loading: null,
      };
      this.corporateConfig = AonConfig.corporate;
      this.submit = (form) => {
        this.messages.success = null;
        this.messages.failure = null;
        this.messages.loading = true;
        const email = this.email_address;
        const context = {
          'email': this.email_address,
        };
        const success = r => { this.messages.success = $interpolate(this.corporateConfig.code_email_retrieval_success)(context); }
        const failure = r => { this.messages.failure = $interpolate(this.corporateConfig.code_email_retrieval_failure)(context); }
        const then = () => { this.messages.loading = false; }
        $http.post(`/corporate/${AonConfig.corporate.id}/retrieve-password`, {email})
          .then(success, failure)
          .finally(then);
      };
    }
  );
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/retrieve-password-ctrl.js